'use strict';

var lib = require('./lib-75591456.js');
var icon = require('./icon-e3ab87ed.js');

var PLUS = 'M12.7502 6H11.2502V11.2498H6V12.7498H11.2502V18H12.7502V12.7498H18V11.2498H12.7502V6Z';
var IconPlus = lib.variant('IconPlus', icon.Icon, {
    path: PLUS,
});

exports.IconPlus = IconPlus;
//# sourceMappingURL=index-a796d6b7.js.map
